<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="column" ref="headerRow"></HeaderRow>
				<div class="banner" v-if="navList[1]&&navList[1].icon_image">
					<el-image style="width: 100%; height: 300px" fit="cover" :src="navList[1].icon_image"></el-image>
				</div>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/column">{{current=='course'?'课程列表':'专栏列表'}}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="container" v-if="current=='course'">
					<div class="content">
						<div class="search">
							<el-input placeholder="当前条件下搜索" v-model="inputStr">
								<el-button slot="append" icon="el-icon-search"></el-button>
							</el-input>
						</div>
						<div class="filter">
							<div class="filterRow">
								<span>专栏：</span>
								<div>
									<a v-for="spec in specialList" :key="spec.name" :class="selSpec.id===spec.id?'seled':''"
										@click="onSelSpec(spec)">{{ spec.name }}</a>
								</div>
							</div>
							<div class="filterRange">
								<span>排序：</span>
								<el-button size="small" @click="onRankPrice()">
									价格
									<i v-if="!rankPrice" class="el-icon-sort"></i>
									<i v-if="rankPrice==='desc'" class="el-icon-sort-down"></i>
									<i v-if="rankPrice==='asc'" class="el-icon-sort-up"></i>
								</el-button>
								<el-button size="small" @click="onRankTime()">
									上架时间
									<i v-if="!rankTime" class="el-icon-sort"></i>
									<i v-if="rankTime==='desc'" class="el-icon-sort-down"></i>
									<i v-if="rankTime==='asc'" class="el-icon-sort-up"></i>
								</el-button>
							</div>
						</div>
						<div class="columnDiv" v-if="courseList.length">
							<div class="columnItem" v-for="(item, index) in courseList" :key="`${index}`"
								@click="gotoDetail(item,'course')">
								<p class="pTag">课程</p>
								<img v-if="item.thumb_image" :src="item.thumb_image" width="100%" height="100%" />
								<img v-else :src="require(`@/assets/home/img_mf/ke${index%8+1}.jpg`)" />
								<p>{{item.title}}</p>
								<p>共{{item.section_num}}课时</p>
								<p v-if="item.price*100 === 0"><span></span><span>免费</span></p>
								<p v-else>
									<span>￥</span><span>{{Price(item.price,2)[0]}}</span><span>.{{Price(item.price,2)[1]}}</span>
								</p>
							</div>
							<div class="pagination">
								<el-pagination background layout="prev, pager, next" :page-size="limit" :total="total"
									@current-change="handleCurrentChange">
								</el-pagination>
							</div>
						</div>
						<el-empty v-else description="暂无数据" :image-size="72"></el-empty>
					</div>
					<div class="list">
						<div class="listTitle" @click="current='column'">
							<p>精品专栏 </p>
							<p>查看<i class="el-icon-arrow-right"></i> </p>
						</div>
						<div class="listContent">
							<div class="courseItem" v-for="(item, index) in specialList" :key="`${index}`"
								@click="gotoDetail(item,'special')">
								<p class="pTag">专栏</p>
								<img v-if="item.thumb_image" :src="item.thumb_image" />
								<img v-else :src="require(`@/assets/home/img_mf/ke${index%8+1}.jpg`)" />
								<p>{{item.name}}</p>
								<p>共{{item.course_num}}讲</p>
								<p v-if="item.price*100 === 0"><span></span><span>免费</span></p>
								<p v-else>
									<span>￥</span><span>{{Price(item.price,2)[0]}}</span><span>.{{Price(item.price,2)[1]}}</span>
								</p>
							</div>
						</div>
					</div>
				</div>

				<div class="container" v-if="!current||current=='column'">
					<div class="content">
						<div class="filter">
							<div class="filterRow">
								<span>科目：</span>
								<div>
									<a v-for="subj in subjectList" :key="subj.subject_id"
										:class="selSubj.subject_id===subj.subject_id?'seled':''"
										@click="onSelSubj(subj)">{{ subj.subject_name }}</a>
								</div>
							</div>
						</div>
						<div class="columnDiv" v-if="specialList.length">
							<div class="columnItem" v-for="(item, index) in specialList" :key="`${index}`"
								@click="gotoDetail(item,'special')">
								<p class="pTag">专栏</p>
								<img v-if="item.image" :src="item.image" width="100%" height="100%" />
								<img v-else :src="require(`@/assets/home/img_mf/ke${index%8+1}.jpg`)" />
								<p>{{item.name}}</p>
								<p>共{{item.course_num}}讲</p>
								<p v-if="item.price*100 === 0"><span></span><span>免费</span></p>
								<p v-else>
									<span>￥</span><span>{{Price(item.price,2)[0]}}</span><span>.{{Price(item.price,2)[1]}}</span>
								</p>
							</div>
						</div>
						<el-empty v-else description="暂无数据" :image-size="72"></el-empty>
					</div>
					<div class="list">
						<div class="listTitle" @click="current='course'">
							<p>精品课程 </p>
							<p>查看<i class="el-icon-arrow-right"></i> </p>
						</div>
						<div class="listContent">
							<div class="courseItem" v-for="(item, index) in courseList" :key="`${index}`"
								@click="gotoDetail(item,'course')">
								<p class="pTag">课程</p>
								<img v-if="item.thumb_image" :src="item.thumb_image" />
								<img v-else :src="require(`@/assets/home/img_mf/ke${index%8+1}.jpg`)" />
								<p>{{item.title}}</p>
								<p>共{{item.section_num}}课时</p>
								<p v-if="item.price*100 === 0"><span></span><span>免费</span></p>
								<p v-else>
									<span>￥</span><span>{{Price(item.price,2)[0]}}</span><span>.{{Price(item.price,2)[1]}}</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},
		computed: {
			Price() {
				return (price, digit) => parseFloat(price).toFixed(digit || 0).split('.');
			},
		},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>